import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthenticationService } from '../services/authentication.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LibraryModule } from './library/library.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './shared/helpers/jwt.interceptor';
import { UserAccessModule } from './screens/user-access/user-access.module';
import { ProgramSetupModule } from './screens/program-setup/program-setup.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule }       from '@angular/material/dialog';
import { FormsModule }         from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ChatbotModule } from './screens/ai/chatbot/chatbot.module';
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LibraryModule,
    BrowserAnimationsModule,
    MatDialogModule,
    FormsModule,
    ChatbotModule
  ],
  providers: [
   AuthenticationService, provideHttpClient(withInterceptorsFromDi()),
   DatePipe,
   { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
